import { DeleteForever, ModeEdit } from "@mui/icons-material";
import { Button, IconButton, TextField, useMediaQuery } from "@mui/material";
import { useAtom } from "jotai";
import { FC, useEffect, useState } from "react";
import { modalDeleteAccount } from "../../../atoms/atom";
import { AccountService } from "../../../services/AccountService";
import { AccountDTO } from "../../../types/AccountDTO";
import EditAccount from "../edit-account/EditAccount";
import ModalDeleteAccount from "../remove-account/ModalDeleteAccount";
import "./Accounts.scss";

const Accounts: FC = () => {
	const [accounts, setAccounts] = useState<AccountDTO[]>([]);
	const [showForm, setShowForm] = useState(false);
	const [search, setSearch] = useState('');
	const [selectedAccount, setSelectedAccount] = useState<Partial<AccountDTO> | null>(null);
	const [accountToDelete, setAccountToDelete] = useState<AccountDTO | null>(null);
	const [deleteModal, setDeleteModal] = useAtom(modalDeleteAccount);
	const isMobile = useMediaQuery('(max-width: 1024px)');
	const service = new AccountService();

	const handleAdd = () => {
		setSelectedAccount({});
		setShowForm(true);
	}

	const handleEdit = (account: AccountDTO) => {
		setSelectedAccount(account);
		setShowForm(true);
	}

	const handleDelete = (account: AccountDTO) => {
		setAccountToDelete(account);
		setDeleteModal(true);
	}

	const handleCloseForm = () => {
		setShowForm(false);
		setSelectedAccount(null);
	}

	useEffect(() => {
		const loadAccounts = async () => {
			const response = await service.getAccounts();
			if (response) {
				setAccounts(response.data);
			}
		};
		if (!showForm) {
			loadAccounts();
		}
	}, [showForm, deleteModal]);

	return (
		<div className="accounts">
			{showForm
				? <EditAccount account={selectedAccount} onClose={handleCloseForm} />
				: <>
				<div className="account-inputs">
					<Button
						id="add-account"
						variant="contained"
						color="success"
						onClick={handleAdd}
					>
						Adicionar usuário
					</Button>
					<TextField
						sx={{width: isMobile ? '100%' : '300px'}}
						label="Buscar usuário por nome ou e-mail"
						id="account-search"
						size="small"
						value={search}
						onChange={(e) => setSearch(e.target.value)}
					/>
				</div>
					<div className="list-accounts">
						{filter().map((account) => (
							<div className="linha-account" key={account.username}>
							<p data-label="Nome">{account.name}</p>
							<p data-label="Usuário">{account.username}</p>
							<div className="account-actions">
								<IconButton
									color="inherit"
									onClick={() => handleEdit(account)}
								>
									<ModeEdit />
								</IconButton>
								<IconButton
									color="inherit"
									onClick={() => handleDelete(account)}
								>
									<DeleteForever sx={{ color: "#e15734db" }}/>
								</IconButton>
							</div>
						</div>
						))}
					</div>
				</>
			}
			<ModalDeleteAccount username={accountToDelete?.username}/>
		</div>
	);

	function filter() {
		if (!search) {
			return accounts;
		}
		return accounts
			.filter(a => a.username.includes(search) || a.name.includes(search));
	}
}

export default Accounts;